export const GA_CAT_PAGE_VIEW = 'page_view';
export const GA_CAT_AUDIO_STREAMING = 'audio_streaming';
export const GA_CAT_SEARCH = 'search';
export const GA_CAT_LOGIN = 'login';
export const GA_CAT_NAVIGATION = 'navigation';
export const GA_CAT_FEATURE_ENGAGEMENT = 'feature_engagement';